
const REM_SIZE = 200;
const px2Rem = (px: number) => `${px / REM_SIZE}rem`;
/**
 * 默认金额展示字体大小
 */
const AMOUNT_FONT_SIZE = 92;

/**
* 单位的默认展示大小样式
*/
const UNIT_FONT_SIZE = {
  'font-size': 38,
  'line-height': 64,
  'margin-top': 36,
};
/**
* 金额的默认展示大小样式
*/
const AMOUNT_DEF_STYLE = {
  'font-size': 92,
  'line-height': 102,
};

export const parseStyles = (styles: { [key: string]: number }, size) => {
  const scaleSize = size / AMOUNT_FONT_SIZE;
  return Object.fromEntries(Object.keys(styles).map(key => [key, px2Rem(styles[key] * scaleSize)]));
};

/** 获取金额字体样式 */
export const getAmountStyle = (size: number) => parseStyles(AMOUNT_DEF_STYLE, size);

/** 获取金额单位或者前缀的字体样式 */
export const getUnitStyle = (size: number) => parseStyles(UNIT_FONT_SIZE, size);
